import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IButton } from '@interfaces/elements';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-loading-generico',
    templateUrl: './loading-generico.component.html',
    styleUrls: ['./loading-generico.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass]
})
export class LoadingGenericoComponent {

  @Input() showOverlay = true;
  @Input() loadingGenerico = false;
  @Input() message: string;
  @Input() buttons: Array<IButton>;

  public get messageString(): string {
    if (this.message) {
      return this.message;
    }
    return 'Por favor aguarde ...';
  }

  constructor() { }

}
